class GwpProgress extends HTMLElement {
  static get observedAttributes() {
    return ['data-gifts-to-remove', 'data-gifts-to-add'];
  }

  attributeChangedCallback(name, oldValue, newValue) {
    if (name === 'data-gifts-to-remove') {
      this.removeInvalidGifts(newValue);
    }
    if (name === 'data-gifts-to-add') {
      this.addGifts(newValue);
    }
  }

  getMiniCart() {
    return document.querySelector('mini-cart');
  }

  getSections() {
    const miniCart = this.getMiniCart();
    return miniCart ? miniCart.getSectionsToRender().map((s) => s.id) : [];
  }

  async removeInvalidGifts(invalidGiftItems) {
    if (!invalidGiftItems) return;

    try {
      const updates = invalidGiftItems
        .split(',')
        .filter(Boolean)
        .reduce((acc, key) => {
          acc[key] = 0;
          return acc;
        }, {});
      const sections = this.getSections();
      const response = await fetch(`${window.Shopify.routes.root}cart/update.js`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ updates, sections }),
      });
      if (!response.ok) {
        throw new Error('Failed to remove invalid gifts');
      }

      const parsedState = await response.json();
      const miniCart = this.getMiniCart();
      if (miniCart) miniCart.renderContents(parsedState);

      if (window.location.pathname === `${Shopify.routes.root}cart`) {
        window.location.reload();
      }
    } catch (error) {
      console.error('Error removing invalid gifts', error);
    }
  }

  async addGifts(giftsToAdd) {
    if (!giftsToAdd) return;

    try {
      const sections = this.getSections();
      const items = giftsToAdd
        .split(',')
        .filter(Boolean)
        .map((key) => {
          const [giftId, variantId] = key.split(':');
          return {
            id: variantId,
            quantity: 1,
            properties: {
              _bl_gwp: giftId,
            },
          };
        });
      const response = await fetch(`${window.Shopify.routes.root}cart/add.js`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ items, sections }),
      });
      if (!response.ok) {
        throw new Error('Failed to add gifts');
      }

      const parsedState = await response.json();
      const miniCart = this.getMiniCart();
      if (miniCart) miniCart.renderContents(parsedState);

      if (window.location.pathname === `${Shopify.routes.root}cart`) {
        window.location.reload();
      }
    } catch (error) {
      console.error('Error adding gifts', error);
    }
  }
}

if (!customElements.get('gwp-progress')) {
  customElements.define('gwp-progress', GwpProgress);
}
